import React, { useCallback, useEffect, useState } from "react";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import s from './SchoolTeachers.module.css';
import { useNavigate } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from './MyButton';
import {MyInput} from '../components/Utilities/MyInput';

import MyComponentLoading from '../components/Utilities/MyComponentLoading';
import SchoolCreateUsers from '../components/SchoolCreateUsers';
import Swal from 'sweetalert2';
import {unsecuredCopyToClipboard} from '../middleware/clipboardService';
import MyPressButton, {MyGreenPressButton} from '../components/Utilities/MyPressButton';

export default function SchoolTeachers(prop) {	
	const navigate = useNavigate();
	
	let schoolId = prop.schoolId;
	const [fetchCompleted, setFetchCompleted] = useState(false);
	const [label, setLabel] = useState('25/26');
	const [users, setUsers] = useState([]);
	const [listUser, setListUser] = useState(true);
	const [batchCreateUser, setBatchCreateUser] = useState(false);
	
	const fetchData = async () => {
		setFetchCompleted(false);
		await getData('schoolApi/listSchoolTeachers?orgId=' + schoolId, navigate)
		.then(res => {
				setUsers(res.data);			
			
				setFetchCompleted(true);
			}
		);
	}
	useEffect(() => {
		fetchData();
	}, []);
	
  const removeClass = async (indexU, userId, username, classId, className) => {
    Swal.fire({
      title: 'Remove class ' + className + ' from ' + username,
      text: 'You won\'t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, do it!',
      cancelButtonText: 'No, cancel!',
    }).then((result) => {
      if (result.isConfirmed) {
				let obj = { userId, classId }
        postData("schoolApi/removeClassFromUser", obj, navigate).then(res => {
						if (res.data == 'fail'){
								Swal.fire({
									title: "Error",
									text: "The user has done something in the class",
									icon: "error"
								});
						} else {
							users[indexU]['classes'] = users[indexU]['classes'].filter((u) => u.id !== classId);
							setUsers([...users]);
						}
					}
				);
      }
    });
  };
	
	if (!fetchCompleted) {
		return (<MyComponentLoading />)
	}
	
	return (<div className={s.mainHolder}>
	
		
			
			<div className={s.paramHolder} style={{display:"flex", alignItems:"center", gap:"10px", padding:"5px", flexWrap:"wrap"}}>
				<div className={s.nonClickableTitle} >Mode:</div>
				<MyPressButton isPressed={listUser} clickedAction={()=>{setListUser(p=>!p)}} bText="List"/>
				<MyPressButton isPressed={batchCreateUser} clickedAction={()=>{setBatchCreateUser(p=>!p)}} bText="Batch Create Teacher"/>
			
			</div>
		
		
		{
			(batchCreateUser) && (<SchoolCreateUsers schoolId={schoolId} triggerAfterCreate={fetchData} userGroup={3}/>)
		}
		
		{(listUser) && ( <div>
			<div style={{display:"flex"}}>
				<MyInput inputLabel={"Label"} dataInput={label} changeAction={(e)=>{
					setLabel(e)
				}} />
				<div>
					<BlueButton isEnabled={true} clickedAction={()=>{ 
						let copy = "username\tnickname\tclass\n";

						let copyArray = [];
						
						for(let u of users) {
							let cArray = [];
							for (let c of u.classes) {
								if (c.label == label) {
									cArray.push(c.name);
								}
							}
							
							if (cArray.length > 0) {
								copyArray.push(u.username + "\t" + u.nickname + "\t" + cArray.join(',') + "\n")
							}
						}
					
						copyArray = copyArray.sort();
						
						unsecuredCopyToClipboard(copy + copyArray.join(''));
					}} bText='Copy User Data' />
				</div>
			</div>
		
		
			<div className={s.rowHolder}>
				<div style={{flexBasis:"300px"}}>Teacher</div>
				<div style={{flexBasis:"auto", whiteSpace:"nowrap"}}>Class</div>
			</div>
		
			{
				users.map((d, indexD)=>(<div key={indexD} className={s.rowHolder} style={(indexD % 2 == 0) ? {background:"#dae6e8"} :{}}>
					<div style={{flexBasis:"300px"}}>
						<div>({d.userId}){d.username}</div>
						<div>{d.nickname}</div>
					</div>
					<div style={{flexBasis:"auto", whiteSpace:"nowrap", display:"flex", gap:"5px", flexWrap:"wrap", width:"calc(100vw - 400px)"}}>
						{
							d.classes.map((c, indexC) => (<div key={indexC}>
								<RedButton 
									overrideStyle={{padding:"0 5px", margin:"2px",border:"2px solid #6c3d19", color:"#6c3d19", fontWeight:"bold", background:"#fbe8d9", width:"150px"}} isEnabled={true} 
									clickedAction={()=>{removeClass(indexD, d.userId, d.username, c.id, c.name)}} bText={"(" + c.id + ")"+ c.name} />
							</div>))
						}
					</div>
				</div>))
			}
		</div>)}
	</div>);
	
}

